import { fromJS } from 'immutable';
import { endLoad, startLoad } from 'portaltransparencia-common/crud/Core.js';

import * as types from './Types.js';

const initialState = fromJS({
  quadroPessoal: []
});

function quadroPessoalReducer(state = initialState, action) {
  switch (action.type) {
    case types.QUADRO_PESSOAL_LIST_START: {
      return startLoad(state);
    }

    case types.QUADRO_PESSOAL_LIST_SUCCESS: {
      return endLoad(state.set('quadroPessoal', fromJS(action.payload)));
    }

    case types.QUADRO_PESSOAL_LIST_ERROR: {
      return endLoad(state);
    }

    case types.RESET_QUADRO_PESSOAL: {
      return initialState;
    }
  }

  return state;
}

export default quadroPessoalReducer;
